document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('[data-tour-stop-link-audio]').forEach(audio => {
    audio.addEventListener('loadedmetadata', () => {
      const p = document.createElement("p");
      const minutesText = (audio.duration == 1) ? "minute" : "minutes";
      p.innerHTML = `${Math.ceil(audio.duration / 60)} ${minutesText}`;
      p.classList.add(
        "$color/alpha:54%",
        "$typography/weight:regular",
        "$typography/scale:down",
        "typography"
      );

      audio.parentElement.insertAdjacentElement('beforeend', p);
    });
  });
});
